import { render, staticRenderFns } from "./InfodaycoUpload.vue?vue&type=template&id=400d7462&scoped=true&"
import script from "./InfodaycoUpload.vue?vue&type=script&lang=ts&"
export * from "./InfodaycoUpload.vue?vue&type=script&lang=ts&"
import style0 from "./InfodaycoUpload.vue?vue&type=style&index=0&id=400d7462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d7462",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VFileInput,VForm,VIcon,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('400d7462')) {
      api.createRecord('400d7462', component.options)
    } else {
      api.reload('400d7462', component.options)
    }
    module.hot.accept("./InfodaycoUpload.vue?vue&type=template&id=400d7462&scoped=true&", function () {
      api.rerender('400d7462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/infodayco/upload/views/InfodaycoUpload.vue"
export default component.exports